import { render } from "./HormoneReplacementContentPtBR.vue?vue&type=template&id=6cdcd88c"
import script from "./HormoneReplacementContentPtBR.vue?vue&type=script&lang=js"
export * from "./HormoneReplacementContentPtBR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__